<template>
    <div class="">
        <!-- <Header></Header> -->
        <div class="page-container">
            <div class="page-wrapper">

                <div class="page-content-container">
                    <div class="page-content-header">
                        <div class="page-header-block"></div>
                        <div @click="handleNav('questing')"
                            :class="tab == 0 ? 'page-content-header-item-active' : 'page-content-header-item'">
                            在线答疑
                        </div>
                        <div @click="handleNav('tel-questing')"
                            :class="tab == 1 ? 'page-content-header-item-active' : 'page-content-header-item'">
                            电话答疑
                        </div>
                    </div>
                    <div class="page-content-wrapper">
                        <div class="page-content">
                            <!-- <router-view></router-view> -->
                            <div v-if="activeNavdy == 'questing'">
                                <LineQuesting :code="code"></LineQuesting>
                            </div>
                            <div v-if="activeNavdy == 'tel-questing'">
                                <TelQuesting :code="code"></TelQuesting>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import LineQuesting from './components/LineQuesting.vue'
import TelQuesting from './components/TelQuesting.vue'
import { canQA } from '../../api/index';
export default {
    name: '',
    components: {
        Header,
        LineQuesting,
        TelQuesting
    },
    data() {
        return {
            code: false,
            activeNavdy: localStorage.getItem('activeNavdy') ? localStorage.getItem('activeNavdy') : "questing",
            dept: '',
            token: '',
            tab: 0,//0tab1高亮1tab2高亮
            navList: ['/questing/line', '/questing/tel'],
            userInfo: {},
            showOtherPlans: true,
        }
    },
    created() {
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        this.getcanQA()
    },
    mounted() {
        scrollTo(0, 0);

        // this.activeNavdy = this.$route.params.mode;
        // this.userInfo = JSON.parse(window.localStorage.getItem('user'));
        // if (this.userInfo && this.userInfo.role === 0) {
        //     this.showOtherPlans = false
        // }
    },
    methods: {
        getcanQA() {
            canQA({}, { Authorization: this.token }).then(res => {
                console.log(res)
                if (res.code == 0) {

                    this.code = true

                } else {
                    this.code = false
                }
            })
        },

        handleNav(val) {
            if (val == 'questing') {
                this.tab = 0
            } else {
                this.tab = 1
            }

            this.activeNavdy = val
            localStorage.setItem('activeNavdy', val)

        },
        viewOtherPlan() {
            this.$router.push(`/managePlan/otherPlan`);
        }
    }
}
</script>

<style scoped>
.page-container {
    width: 100%;
    margin: 0 auto;
    margin-top: 50px;
}

.page-wrapper {
    width: 1200px;
    margin: 0 auto;

}

.page-back-wrapper {
    width: 100%;
    height: 68px;
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #f0f0f3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 18px;
}

.page-back-img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    display: inline-block;
    position: relative;
    top: 2px;
}

.page-back {
    display: flex;
    align-items: center;
    margin-left: 30px;
    cursor: pointer;
}

.nav-line-wrapper {
    width: 100%;
    bottom: 15px;
    left: 0px;
    position: absolute;
    display: flex;
    justify-content: center;
    margin-top: 6px;
}

.nav-line {
    width: 22px;
    height: 6px;
    background: #4F79ED;
    border-radius: 3px;
}

.page-content-container {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    /* margin-top: 18px; */
}

.page-content-header {
    width: 100%;
    height: 50px;
    border-radius: 6px 5px 0px 0px;
    line-height: 50px;
    position: relative;
    display: flex;
    background: #e8efff;
}

.page-header-block {
    width: 6px;
    height: 24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left: 0px;
    top: 28px;
    z-index: 99;
}

.page-content-header-item {
    width: 170px;
    height: 100%;
    text-align: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
    position: relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.page-content-header-item:hover {
    color: #4F79ED;
    cursor: pointer;
}

.page-content-header-item-active {
    width: 170px;
    height: 100%;
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3E63EE;
    cursor: pointer;
    position: relative;
    background: #fff;
}

.page-content-wrapper {
    display: flex;
}

.page-content {
    flex: 1;
    margin: 0px 41px 50px 0px;
}

.other-plan-btn {
    width: 108px;
    height: 36px;
    border-radius: 6px;
    border: 1px solid #FF9645;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF9645;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 40px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.other-plan-btn:hover {
    cursor: pointer;
    background: #FF9645;
    color: #fff;
}
</style>


